/* DSL A/B test framework — variant assignment via localStorage, event-bus voor analytics */
(function(w){
  var KEY = "dsl_ab_assignments";
  var EVT = "dsl_ab_event";
  function getAll(){ try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch(e) { return {}; } }
  function setAll(o){ try { localStorage.setItem(KEY, JSON.stringify(o)); } catch(e){} }
  // Stable assignment using a hash of (test+visitorId) → first variant in list
  function hash(s){ var h=0,i,c; for(i=0;i<s.length;i++){c=s.charCodeAt(i);h=((h<<5)-h)+c;h|=0;} return Math.abs(h); }
  function visitorId(){
    var k="dsl_vid", v=null;
    try { v = localStorage.getItem(k); } catch(e){}
    if (!v){ v = (Date.now().toString(36)+Math.random().toString(36).slice(2,10)); try{ localStorage.setItem(k,v); }catch(e){} }
    return v;
  }
  var DSL_AB = {
    visitorId: visitorId,
    getVariant: function(testName, variants){
      if (!variants || !variants.length) return null;
      var assignments = getAll();
      if (assignments[testName] && variants.indexOf(assignments[testName]) >= 0) return assignments[testName];
      var idx = hash(testName + visitorId()) % variants.length;
      var chosen = variants[idx];
      assignments[testName] = chosen;
      setAll(assignments);
      // Emit assignment event
      DSL_AB.emit("assignment", {test: testName, variant: chosen});
      return chosen;
    },
    track: function(eventName, payload){ DSL_AB.emit(eventName, payload || {}); },
    emit: function(name, data){
      try {
        var detail = {name: name, data: data, ts: Date.now(), vid: visitorId(), assignments: getAll()};
        w.dispatchEvent(new CustomEvent(EVT, {detail: detail}));
        // Optional: forward to GA4 / dataLayer if present
        if (w.dataLayer && typeof w.dataLayer.push === "function") {
          w.dataLayer.push({event: "dsl_ab_" + name, dsl_ab: detail});
        }
      } catch(e){}
    },
    on: function(handler){ w.addEventListener(EVT, function(e){ handler(e.detail); }); },
    reset: function(){ try { localStorage.removeItem(KEY); } catch(e){} }
  };
  w.DSL_AB = DSL_AB;
})(window);